import { Pagination } from 'antd';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PaginationRange } from '../../constant/constant';
import {
  usePageNumber,
  usePageSize,
  useSetPageNumber,
  useSetPagination,
  useSetPageSize,
} from './PaginationQuery';

const TmPagination = ({
  total,
  pageSize,

  onShowSizeChange,
  handlePagination,
  defaultCurrent,
}) => {
  const setPagination = useSetPagination();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageNumber = usePageNumber();
  const pageSizes = usePageSize();
  const onChange = (page, size) => {
    setPagination(page, size);
    searchParams.set('pageNumber', page);
    searchParams.set('pageSize', size);
    setSearchParams(searchParams);

    handlePagination(page);
  };
  console.log({ pageNumber, pageSize });
  return (
    <div className="text-end">
      <Pagination
        current={pageNumber}
        defaultCurrent={defaultCurrent || 1}
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        total={total}
        size="small"
        showQuickJumper
        pageSize={pageSizes}
        onChange={onChange}
        showTotal={(total) => `Total ${total} items`}
      />
    </div>
  );
};

export default TmPagination;
